export const dispatchSearchRefreshEvent = (data) => {
  const searchRefreshEvent = new CustomEvent("beon.search.results.refresh", {
    detail: { data },
  });
  document.dispatchEvent(searchRefreshEvent);
};
